<template>
	<a :class="buttonClassList" :href="href" v-tooltip="tooltip" @click="clickHandler($event)">
		<svg :class="classList" :width="iconSize" :height="iconSize">
			<use xmlns:xlink="http://www.w3.org/1999/xlink" :xlink:href="'#' + type"></use>
		</svg>
	</a>
</template>

<script type="text/babel">
export default {
	props: {
		color: { default: "fade" }, // fade, brand, white, inherit
		extraClasses: { default: "" },
		href: { default: "#" },
		type: { default: "" },
		flip: { default: false },
		tooltip: { default: null },
		rotate: { default: 0 },
		size: { default: "normal" }, // normal, large
		buttonSize: { default: "normal" }, // normal, input, input-large, large
	},

	methods: {
		clickHandler(event) {
			event.stopPropagation();
		},
	},

	computed: {
		iconSize() {
			switch (this.size) {
				default:
				case "normal":
					return 16;

				case "medium":
					return 18;

				case "large":
					return 24;

				case "huge":
					return 48;
			}
		},

		viewBoxSize() {
			return "0 0 " + this.iconSize + " " + this.iconSize;
		},

		classList() {
			let classList = "icon";

			classList += " color-" + this.color;
			classList += " type-" + this.type;
			classList += " " + this.size;

			if (this.flip) {
				classList += " flip";
			}

			if (this.rotate !== 0) {
				classList += " rotate-" + this.rotate;
			}

			if (this.extraClasses !== "") {
				classList += " " + this.extraClasses;
			}

			return classList;
		},

		buttonClassList() {
			let classList = "icon-button icon-button-link";

			classList += " size-" + this.buttonSize;
			classList += " icon-size-" + this.size;

			return classList;
		},
	},
};
</script>

<style lang="scss">
.icon {
	display: inline-block;
	vertical-align: middle;

	& + span {
		margin-left: 6px;
	}

	&.normal {
		width: 16px;
		height: 16px;
	}

	&.medium {
		width: 18px;
		height: 18px;
	}

	&.large {
		width: 24px;
		height: 24px;
	}

	// Flip
	&.flip {
		transform: scaleX(-1);
	}

	&.rotate-45 {
		transform: rotate(45deg);
	}

	&.rotate-90 {
		transform: rotate(90deg);
	}

	&.rotate-135 {
		transform: rotate(135deg);
	}

	&.rotate-180 {
		transform: rotate(180deg);
	}

	&.rotate-225 {
		transform: rotate(225deg);
	}

	&.rotate-270 {
		transform: rotate(270deg);
	}

	&.rotate-315 {
		transform: rotate(315deg);
	}

	// Colors
	&.color-inherit {
		color: inherit;
	}

	&.color-fade {
		color: #a8b1c3;
	}

	&.color-white {
		color: #fff;
	}

	&.color-brand {
		color: #7061ff;
	}
}

span + .icon {
	margin-left: 6px;
}
</style>
